import type { DataSourceSortInfo } from "@infinite-table/infinite-react";
import type { SortParams } from "epsm-api-types";
import type { ScreenerData } from "epsm-api-types/models";

export const getSortInfo = (
	sort: SortParams | undefined,
): DataSourceSortInfo<ScreenerData> | undefined => {
	if (!sort) return;
	return sort.map((sortParams) => ({
		field: sortParams.name,
		dir: sortParams.order,
	}));
};
